// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14AgX","index":"styles_index__N_X_f"};